
import React from 'react';
import {DashboardTable} from "../../components/dashboard-table";
import { sprintf } from "sprintf-js";
import { Action } from "../../funcs/utils";
import {getRGB} from "../../../lib/color";
import {HEADER_SORT} from "./common";
import {process_pay_frequency} from "../../../lib/time/pay_frequency";

const ArrowUp = () => (<i className="fa fa-arrow-up"/>);
const ArrowDown = () => (<i className="fa fa-arrow-down"/>);

const render_buy_button = (component, index, selected_row, data_index) => {
  const style = {
    padding: "0",
    width: "5rem",
    height: "100%",
    color: "#888",
    fontWeight: "normal",
  }
  if (index !== selected_row) {
    style.visibility = "hidden";
  }
  if (component.state.over_buy) {
    style.color = "#000";
    style.fontWeight = "bold";
  }

  const onEnter = (id, enter) => {
    component.setState({
      over_buy: enter,
    })
  }
  return (
    <Action
      onMouseEnter={onEnter}
      style={style}
      onClick={() => component.onBuyClick(data_index)}
    >
      Buy
    </Action>
  );
}

const gen_headers = (component, headers, term_index, table_name) => {
  const on_header_click = (index, col) => () => {
    if (component.state.header_sort.index === index) {
      if (component.state.header_sort.dir === HEADER_SORT.INCR) {
        component.sort_items(table_name, col, HEADER_SORT.DECR);
      } else {
        component.sort_items(table_name, "Term", HEADER_SORT.INCR);
      }
    } else {
      component.sort_items(table_name, col, HEADER_SORT.INCR);
    }
  }

  const result = [];
  for(let i=0; i < headers.length; i++) {
    const header_sort = component.state.header_sort;
    let arrow;
    if (header_sort && header_sort.index === i && header_sort.dir === HEADER_SORT.INCR) {
      arrow = ArrowUp();
    } else if (header_sort && header_sort.index === i && header_sort.dir === HEADER_SORT.DECR) {
      arrow = ArrowDown();
    }
    result.push((
      <div
        onClick={on_header_click(i, headers[i])}
        style={{ display: "flex"}}>
        <div>{headers[i]}</div>
        <div style={{ flex: "1"}}/>
        <div>{arrow}</div>
      </div>
    ))
  }
  return result;
}

const generate_table_data = (table, items, component, selected_row, no_buy_column) => {

  let term_index = table.columns.indexOf("Term");
  const headers = gen_headers(component, table.columns, term_index, table.table_name);
  if (!no_buy_column) {
    headers.unshift("");
  }
  let result = [ headers ];

  for(let i=0; i < items.length; i++) {
    const item = items[i];
    if (item.hidden_cusip) {
      continue;
    }
    const line = [];
    if (!no_buy_column) {
      line.push(render_buy_button(component, result.length - 1, selected_row, i));
    }
    table.columns.forEach(col => {
      if (col === "Pay Frequency") {
        line.push(process_pay_frequency(item[col]));
      } else if (col === "Coupon") {
        item[col] = item[col].replace("%", "");
        line.push(sprintf("%.02f", item[col]));
      } else if (col === "Price") {
        const price_pct = item[col].endsWith("%")
          ? item[col]
          : item[col] + "%";
        line.push(price_pct);
      } else {
        line.push(item[col]);
      }
    });
    result.push(line);
  }

  return result;
}

const OfferingsTable = props => {

  const component = props.component;
  const logged_in = component.props.user.token;
  const selected_row = props.selected_row;
  const no_buy_column = props.no_buy_column;
  const col_offset = no_buy_column ? 0 : 1;
  const data = generate_table_data(
    props.table, props.items, component, selected_row, no_buy_column);
  const header_color = getRGB(props.header_color);
  const sort_col = component.state.header_sort
    ? component.state.header_sort.index : -10;

  const style_lut = [

    // Alternating BG color
    {
      pred: (row, col) => row % 2 === 0 && (no_buy_column || col > 0),
      style: {
        background: "#EEE",
      }
    },

    // Mouse over row
    {
      pred: (row, col) =>
        row - 1 === selected_row && selected_row !== -1 && (no_buy_column || col > 0),
      style: {
        background: "#DDD",
      }
    },

    // Header
    {
      pred: (row, col) => row === 0 && (no_buy_column || col > 0),
      style: {
        background: header_color,
        fontWeight: "bold",
        fontSize: "1.1rem",
      }
    },
    // Header sort column
    {
      pred: (row, col) => row === 0 && col - col_offset === sort_col,
      style: {
        background: "black",
        color: header_color,
      }
    },
    {
      pred: (row, col) => no_buy_column || col > 0,
      style: {
        paddingLeft: "0.5rem",
        paddingRight: "0.5rem",
        paddingTop: "0",
        paddingBottom: "0",
        border: "solid black 1px",
      }
    },
    {
      style_fn: (row, col) => {
        const result = {};
        if (col === 0) {
          // BUY button
          return {
            width: "5rem",
          };
        }

        if (logged_in && col === 4) {
          // Issuer
          return {
            width: "20rem",
          }
        }

        if (!logged_in && col === 3) {
          // Issuer
          return {
            width: "20rem",
          }
        }
        return result;
      }
    }
  ]

  return (
    <div>
      <DashboardTable
        tableStyle={props.tableStyle}
        tdStyleLut={style_lut}
        onMouseRowEvent={component.onMouseRowEvent}
        onMouseRowClick={component.onMouseRowClick}
        data={data}
        />
    </div>
  )
}

export { OfferingsTable };
